import * as yup from "yup";
import {
  createAccessTypeValidation,
  createExpirationDateValidation,
  workspaceAssignmentErrorMessages,
} from "~/pages/UserAndRoles/utils/workspaceAssignmentValidation";
import type { ArenaAccessRow } from "~/pages/Dashboard/components/WorkspaceTable";

const errorMessages = {
  arenaId: "Workspace is required",
  roleGroupName: workspaceAssignmentErrorMessages.roleGroupName,
  existingAssignment: "User already has an active assignment to this workspace",
};

export const validationSchema = (existingAssignments: ArenaAccessRow[] = []) =>
  yup.object().shape({
    arenaId: yup
      .string()
      .required(errorMessages.arenaId)
      .test("no-existing-assignment", errorMessages.existingAssignment, function (value) {
        if (!value) return true;
        const hasActiveAssignment = existingAssignments.some(
          (assignment) => assignment.arenaId === value && assignment.active,
        );
        return !hasActiveAssignment;
      }),
    roleGroupName: yup.string().required(errorMessages.roleGroupName),
    accessType: createAccessTypeValidation(),
    expirationDate: createExpirationDateValidation(),
  });
